function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultAlertWarning = function SvgLivemapSearchresultAlertWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9763"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    "data-name": "Ellipse 608",
    style: {
      fill: "#fbae2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11024.563 571.207h2.05l-.342 5.64h-1.253z",
    "data-name": "Path 11766",
    style: {
      fill: "#fff"
    },
    transform: "translate(-11017.614 -568.125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2v2H0z",
    "data-name": "Rectangle 4590",
    style: {
      fill: "#fff"
    },
    transform: "translate(7.051 10.041)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.333v15.333H0z",
    "data-name": "Rectangle 4596",
    style: {
      fill: "none"
    },
    transform: "translate(.667)"
  }));
};
export default SvgLivemapSearchresultAlertWarning;